import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BookingService {
  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  create(form: any): any{
    return this.http.post(`${this.url}/booking/create`, form);
  }

  update(id: string, data: any): any{
    return this.http.post(`${this.url}/booking/update/${id}`, data)
  }

  delete(data: any): any{
    return this.http.post(`${this.url}/booking/delete`, data)
  }

  getTimeSlots(data): any{
    return this.http.post(`${this.url}/booking/timeslots`, data)
  }

  getAllByOrganization(filter: any): any {
    return this.http.post(`${this.url}/bookings/organization`, filter);
  }

  getAllForScheduler(filter: any): any {
    return this.http.get(`${this.url}/bookings/scheduler`, { params: filter });
  }

  getAvailableDurations(filter: any): any{
    return this.http.get(`${this.url}/bookings/scheduler/availability`, { params: filter });
  }

  getDashboard(id: string): any{
    return this.http.get(`${this.url}/bookings/dashboard/${id}`);
  }

  getPaymentIntent(id: string, stripeAccountId: string): any{
    return this.http.get(`${this.url}/booking/paymentintent/${id}`, { params: { stripeAccountId } });
  }

  getPaymentMethodForRefundOrAdditionalPayment(data): any{
    return this.http.post(`${this.url}/booking/paymentintent/search`, data);
  }

  getAddons(id: string): any {
    return this.http.get(`${this.url}/booking/addons/${id}`);
  }

  refund(data): any{
    return this.http.post(`${this.url}/booking/refund`, data);
  }

  processAdditionalPayment(data): any{
    return this.http.post(`${this.url}/booking/additionalpayment`, data);
  }

  createCustomer(data): any{
    return this.http.post(`${this.url}/booking/customer/create`, data);
  }

  getReferenceBookings(filter: any): any{
    return this.http.get(`${this.url}/bookings/reference`, { params: filter });
  }
}
